module.exports = __webpack_public_path__ + "img/21.76643829.gif";